export enum VEventTypeEnum {
    gameEvent = "gameEvent"
}

export enum VEventEnum {
    autoPlayInterrupt = "autoPlayInterrupt",
    autoPlayStarted = "autoPlayStarted",
    autoPlayStopped = "autoPlayStopped",
    balanceUpdate = "balanceUpdate",
    balanceUpdateTwo = "balanceUpdateTwo",
    betSizeUpdate = "betSizeUpdate",
    bonusgameComplete = "bonusgameComplete",
    bonusgameStarted = "bonusgameStarted",
    deviceLocked = "deviceLocked",
    displayError = "displayError",
    externalInfoUpdate = "externalInfoUpdate",
    fatalError = "fatalError",
    fullscreenOverlayRemoved = "fullscreenOverlayRemoved",
    fullscreenOverlayShown = "fullscreenOverlayShown",
    gameInitialized = "gameInitialized",
    gameLoaderReady = "gameLoaderReady",
    gameMetric = "gameMetric",
    gameReady = "gameReady",
    gameReadyToUnload = "gameReadyToUnload",
    gameRoundCompleted = "gameRoundCompleted",
    gameSetMute = "gameSetMute",
    gamemenuClosed = "gamemenuClosed",
    gamemenuOpen = "gamemenuOpen",
    gameplayPause = "gameplayPause",
    gameplayResume = "gameplayResume",
    gameplayStart = "gameplayStart",
    gamescreenBusy = "gamescreenBusy",
    gamescreenFree = "gamescreenFree",
    loadProgressUpdate = "loadProgressUpdate",
    megaWinSummaryClosed = "megaWinSummaryClosed",
    megaWinTriggered = "megaWinTriggered",
    navigationSwipeLeft = "navigationSwipeLeft",
    navigationSwipeRight = "navigationSwipeRight",
    orientationChanged = "orientationChanged",
    overlayRemoved = "overlayRemoved",
    overlayShown = "overlayShown",
    playerAttentionRequired = "playerAttentionRequired",
    playerInformationRecieved = "playerInformationRecieved",
    pluginSetMute = "pluginSetMute",
    portraitOverlayRemoved = "portraitOverlayRemoved",
    portraitOverlayShown = "portraitOverlayShown",
    preloaderRemoved = "preloaderRemoved",
    preloaderStarts = "preloaderStarts",
    preventGamePlay = "preventGamePlay",
    realityCheckLimitReached = "realityCheckLimitReached",
    resizeWindowOverlayRemoved = "resizeWindowOverlayRemoved",
    resizeWindowOverlayShown = "resizeWindowOverlayShown",
    resultShown = "resultShown",
    sessionActivity = "sessionActivity",
    showMegaWinSummary = "showMegaWinSummary",
    soundOff = "soundOff",
    soundOn = "soundOn",
    symbolsLoadingEnd = "symbolsLoadingEnd",
    symbolsLoadingStart = "symbolsLoadingStart",
    systemBalanceUpdate = "systemBalanceUpdate",
    topBarBalanceUpdate = "topBarBalanceUpdate",
    tutorialDismissed = "tutorialDismissed",
    tutorialShown = "tutorialShown",
    viewPorterUpdated = "viewPorterUpdated",
    willClosingGameGenerateUnfinishedGameResponse = "willClosingGameGenerateUnfinishedGameResponse",
    winUpdate = "winUpdate",
    windowResized = "windowResized"
}

export enum WagerLimitReasons {
    /**
     * No limits have been exceeded.
     */
    none = "none",
    /**
     * Spin count limit reached
     */
    wagerCount = "wagerCount",
    /**
     * Loss limit reached
     */
    lossLimit = "lossLimit",
    /**
     * Win limit reached
     */
    winLimit = "winLimit"
}
